import React, { useEffect, useState } from "react";
import { Route, Routes, useNavigate, useLocation } from "react-router-dom";
import NotFound from "./404/404";
import Header from "./_components/Header/Header";
import { ScrollToTop } from "_styleguide";
import { useSettings } from "_contexts/useSettings";
import { useLead } from "_contexts/useLead";
import { useGTMPageTracking } from "_contexts/_helpers/useGTMPageTracking";
import { generateRootRoute, generateRoute, getSettings } from "./_helpers";
import DeadEnd from "./DeadEnd/DeadEnd";
import "./Apply.scss";

function Apply(props) {
  const { settings, flow, isPreview } = useSettings();
  const { lead } = useLead();
  const navigate = useNavigate();
  const location = useLocation();
  const [hasRedirected, setHasRedirected] = useState(false);
  useGTMPageTracking(); // Track page views in GTM

  // Check for dead end localStorage and redirect if needed
  useEffect(() => {
    const isDeadEnd = localStorage.getItem("pp_dead_end");
    const isOnDeadEndPage = location.pathname === "/contact-us";

    // If user has reached dead end before and is not already on the dead end page, redirect them
    if (isDeadEnd === "true" && !isOnDeadEndPage && !isPreview) {
      navigate("/contact-us", { replace: true });
    }
  }, [navigate, location.pathname, isPreview]);

  // Redirect to current_step if user is returning and on root path
  useEffect(() => {
    // Only redirect once, on initial load, and only if we have the data we need
    if (hasRedirected || isPreview || !lead?.current_step || !flow?.length) {
      return;
    }

    const isOnRootOrScreening =
      location.pathname === "/" || location.pathname === "/screening";

    // If user is on root/screening and has a saved current_step, redirect them
    if (isOnRootOrScreening && lead.current_step) {
      // Verify the step exists in the current flow
      const stepExists = flow.some((page) => page.name === lead.current_step);

      if (stepExists) {
        setHasRedirected(true);
        navigate(`/${lead.current_step}`, { replace: true });
      }
    }
  }, [lead?.current_step, flow, location.pathname, navigate, isPreview, hasRedirected]);

  return !settings || !flow ? null : (
    <React.Fragment>
      <Header />
      <div id="app-scroll">
        <ScrollToTop />

        <Routes>
          {/* NOT FOUND */}
          <Route path="*" element={<NotFound {...props} />} />

          {/* DEFINED ROOT PATH */}
          {generateRootRoute(flow)}

          {/* DEAD END */}
          <Route
            path="/contact-us"
            element={
              <DeadEnd {...props} settings={getSettings(flow, "dead_end")} />
            }
          />

          {/* ALL OTHER PATHS */}
          {flow.map((page) => {
            // Use pageId if available (for custom pages), otherwise use name
            const routeId = page.pageId || page.name;
            return generateRoute(flow, routeId);
          })}
        </Routes>
      </div>
    </React.Fragment>
  );
}

export default Apply;
